import { useSelectorKiosk } from "./useSelectorKiosk";

const useVeille = () => {
    const selector = useSelectorKiosk(state => state.veille)
    return selector;
}

export default useVeille;